module.exports = __webpack_public_path__ + "img/alipayicon.50f0509.png";